import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import PrimaryButton from "../Button/PrimaryButton";

export default function CustomCard({ title, children, className, childrenClassName, buttonTitle, onClick, backable = true, ...props }) {
    const history = useHistory();
    return (
        <div className={`label-table ${className}`}>
            {title || backable || buttonTitle ? (
                <div className="surface-300 py-3 px-3 flex justify-content-start w-full m-0 flex justify-content-between">
                    <div className="flex">
                        {backable ? <i className="pi pi-angle-left text-4xl my-auto cursor-pointer" onClick={() => history.goBack()} /> : null}
                        {title ? <div className="text-2xl my-auto">{title}</div> : null}
                    </div>
                    {buttonTitle ? <PrimaryButton severity="secondary" className="mt-2 md:mt-0" onClick={onClick} label={buttonTitle} /> : null}
                </div>
            ) : null}
            <div className={`p-7 border border-1 border-300 p-fluid ${childrenClassName}`}>{children}</div>
        </div>
    );
}
